var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scroller",staticClass:"pdfz",on:{"wheel":_vm.onWheel}},[(_vm.loading)?_c('div',{staticClass:"pdfz__state"},[_c('i',{staticClass:"mdi mdi-loading mdi-spin"}),_c('span',[_vm._v(_vm._s(_vm.$t("course.loadingPdf")))])]):_vm._e(),_c('div',{staticClass:"pdfz__pages"},_vm._l((_vm.pages),function(p){return _c('div',{key:p.num,staticClass:"pdfz__page",style:({
        width: `${Math.floor(p.width * _vm.scale)}px`,
        height: `${Math.floor(p.height * _vm.scale)}px`,
      }),attrs:{"data-num":p.num}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }